module.exports = "/assets/data/00fee42c4eb0a244699c675a49103b0b-CM3.data.json";